    <template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout wrap>
      <v-snackbar
        v-model="showsnackbar"
        color="#9eaade"
        right
        :timeout="timeout"
      >
        <v-layout wrap justify-center>
          <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
          <v-flex text-right>
            <v-btn small :ripple="false" text @click="showsnackbar = false">
              <v-icon style="color: white">mdi-close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-snackbar>
      <v-dialog v-model="dialog" width="400px">
        <v-card width="400px">
          <v-layout wrap pa-5>
            <v-flex xs12 text-center pb-5 style="font-family: nunitosansbold">
              Are you sure you want to delete this Notice?</v-flex
            >
            <v-flex xs12>
              <v-layout wrap justify-end text-right>
                <v-flex align-self-center sm2 xs6
                  ><v-btn
                    text
                    color="blue darken-1"
                    @click="removeNotice(noticeData1._id)"
                  >
                    yes</v-btn
                  ></v-flex
                >
                <v-flex align-self-center sm2 xs6
                  ><v-btn text color="blue darken-1" @click="dialog = false">
                    No</v-btn
                  ></v-flex
                >
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
      <v-flex xs12 md9>
        <span style="font-family: nunitosansbold; font-size: 18px"
          >Noticeboard</span
        >
      </v-flex>

      <v-flex xs3>
        <router-link style="text-decoration: none" :to="{ path: '/noticeadd' }">
          <v-btn
            width="275px"
            outlined
            style="text-transform: none; font-size: 10px"
            color="#747474"
            >Create new Notice
          </v-btn>
        </router-link>
      </v-flex>
      <v-flex xs12 pt-5 pb-12>
        <v-layout wrap py-5>
          <v-flex xs12>
            <v-card>
              <div v-if="noticeData1.image && !img">
                <v-img max-height="400" :src="mediaURL + noticeData1.image">
                  <v-layout pa-8 wrap fill-height>
                    <v-flex style="opacity: 0" xs12 sm1 align-self-start>
                      <!-- <input
                              ref="files2"
                              type="file"
                              :multiple="false"
                              style="display: none"
                              id="fileUpload"
                              @change="browseImages2"
                            />
                    <v-icon @click="$refs.files2.click()" large color="white"
                      >mdi-image-outline</v-icon> -->
                      <!-- <CoverImageComp
                        @stepper="winStepper"
                        :height="'5118'"
                        :width="'8001'"
                        :heading="'Upload Cover Image'"
                        :componentType="'coverImage'"
                      /> -->
                    </v-flex>
                    <v-flex xs12 align-self-end pb-12>
                      <v-layout wrap>
                        <v-flex
                          md10
                          class="hidden-sm-and-down"
                          style="
                            font-family: nunitosansextrabold;
                            font-size: 40px;
                            color: white;
                          "
                        >
                          {{ title }}
                        </v-flex>
                        <v-flex md2 text-right align-self-end>
                          <v-icon color="white">mdi-attachment</v-icon
                          ><span
                            style="color: white"
                            v-if="document.length > 0"
                            >{{ document.length }}</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-img>
              </div>
              <div v-else>
                <v-img max-height="400" :src="img">
                  <v-layout pa-8 wrap fill-height>
                    <v-flex style="opacity: 0.9" xs12 sm1 align-self-start>
                      <!-- <CoverImageComp
                        @stepper="winStepper"
                        :height="'5118'"
                        :width="'8001'"
                        :heading="'Upload Cover Image'"
                        :componentType="'coverImage'"
                      /> -->
                    </v-flex>
                    <v-flex xs12 align-self-end pb-12>
                      <v-layout wrap>
                        <v-flex
                          md10
                          class="hidden-sm-and-down"
                          style="
                            font-family: nunitosansextrabold;
                            font-size: 40px;
                            color: white;
                          "
                        >
                          {{ title }}
                        </v-flex>
                        <v-flex md2 text-right align-self-end>
                          <v-icon color="white">mdi-attachment</v-icon
                          ><span
                            style="color: white"
                            v-if="document.length > 0"
                            >{{ document.length }}</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-img>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout wrap pt-5>
          <v-flex>
            <v-card
              :style="
                $vuetify.breakpoint.name == 'xs'
                  ? 'height: 800px'
                  : (style = 'height: 100%')
              "
            >
              <v-layout wrap pa-2 pa-sm-8>
                <v-flex
                  xs12
                  style="font-family: nunitosansextrabold; font-size: 20px"
                >
                  Edit this Notice
                </v-flex>
                <v-flex xs12 py-4 style="font-family: nunitosansbold">
                  Subject
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    style="font-family: nunitosansextrabold; font-size: 30px"
                    v-model="title"
                    flat
                  >
                  </v-text-field>
                </v-flex>
                <!-- <v-flex xs12>
                  <v-divider> </v-divider>
                </v-flex> -->
                <v-flex xs12 py-5 style="font-family: nunitosansbold">
                  Text
                </v-flex>
                <v-flex xs12>
                  <v-textarea v-model="description" rows="6" flat> </v-textarea>
                </v-flex>
                <v-layout justify-start wrap>
                  <v-flex xs10>
                    <span style="font-family: nunitosansbold"
                      >Upload Image</span
                    >
                  </v-flex>
                  <v-flex xs4 text-left>
                    <CoverImageComp
                      @stepper="winStepper"
                      :height="'5118'"
                      :width="'8001'"
                      :singleImage="noticeData1.image"
                      :heading="'Upload Cover Image'"
                      :componentType="'coverImage'"
                    />
                  </v-flex>
                </v-layout>
                <v-flex xs12>
                  <v-divider> </v-divider>
                </v-flex>
                <v-flex xs12 py-5 v-if="document.length > 0">
                  <span><v-icon>mdi-attachment</v-icon></span> Attachments
                  <span></span>
                </v-flex>
                <v-flex xs12 py-5>
                  <v-btn
                    style="margin-left: 1%"
                    elevation="0"
                    v-for="(item, i) in document"
                    :key="i"
                    @click="removeDoc(i)"
                  >
                    <span>{{ item }}</span>
                    <span style="padding-left: 10%"
                      ><v-icon>mdi-close</v-icon></span
                    >
                  </v-btn>
                </v-flex>
                <v-flex
                  v-if="document.length > 0"
                  pb-5
                  style="border-top: 1px dotted; width: 10px"
                >
                </v-flex>
                <v-flex xs12 pt-3>
                  <v-layout wrap justify-start>
                    <v-flex xs12 class="hidden-sm-and-down">
                      <v-layout wrap>
                        <v-flex xs12 md4>
                          <span>
                            <input
                              ref="files"
                              type="file"
                              multiple
                              style="display: none"
                              id="fileUpload"
                              @change="browseDocs"
                            />
                            <v-btn
                              @click="$refs.files.click()"
                              elevation="0"
                              width="100%"
                              ><span style="text-transform: none"
                                >Upload New Attachment
                              </span>
                              <span
                                ><v-icon>mdi-upload-outline</v-icon></span
                              ></v-btn
                            >
                          </span>
                        </v-flex>
                        <v-flex xs12 md2 px-2>
                          <span
                            ><v-btn
                              @click="dialog = true"
                              elevation="0"
                              width="100%"
                              ><span style="text-transform: none">Delete</span
                              ><span
                                ><v-icon>mdi-delete-outline</v-icon></span
                              ></v-btn
                            ></span
                          >
                        </v-flex>
                        <v-flex md6>
                          <span
                            ><v-btn
                              @click="editData"
                              elevation="0"
                              width="100%"
                              color="#9B8DFD"
                              ><span style="text-transform: none"
                                >SUBMIT
                              </span></v-btn
                            ></span
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="hidden-md-and-up" text-center>
                      <v-layout justify-center wrap>
                        <v-flex xs12 pb-5>
                          <span style="padding-right: 10px">
                            <input
                              ref="files"
                              type="file"
                              multiple
                              style="display: none"
                              id="fileUpload"
                              @change="browseDocs"
                            />
                            <v-btn
                              @click="$refs.files.click()"
                              elevation="0"
                              max-width="300px"
                              ><span style="text-transform: none"
                                >Upload Attachment
                              </span>
                              <span
                                ><v-icon>mdi-upload-outline</v-icon></span
                              ></v-btn
                            ></span
                          >
                        </v-flex>
                      </v-layout>
                      <span style="padding-right: 20px"
                        ><v-btn
                          @click="dialog = true"
                          elevation="0"
                          width="160px"
                          ><span style="text-transform: none">Delete</span
                          ><span
                            ><v-icon>mdi-delete-outline</v-icon></span
                          ></v-btn
                        ></span
                      >
                      <span>
                        <v-btn
                          @click="editData"
                          elevation="0"
                          max-width="570"
                          color="#9B8DFD"
                          ><span style="text-transform: none"
                            >SUBMIT
                          </span></v-btn
                        >
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex> </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import CoverImageComp from "./singleImage2";
export default {
  components: {
    CoverImageComp,
  },
  data() {
    return {
      dialog: false,
      docs: [],
      docsdata: new FormData(),
      photo: new FormData(),
      document: [],
      noticeData1: [],
      title: "",
      description: "",
      showsnackbar: false,
      timeout: 5000,
      msg: "",
      appLoading: false,
      coverImageFile: null,
      selectedFiles: "",
      image: null,
      img: null,
    };
  },
  mounted() {
    this.getData();
    this.documentUpdate();
  },
  methods: {
    documentUpdate() {
      axios({
        method: "GET",
        url: "/notice/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.query.key,
        },
      }).then((response) => {
        if (response.data.status) {
          this.document = [];
          for (var i = 0; i < response.data.data.docs.length; i++) {
            this.document.push(response.data.data.docs[i]);
          }
          this.image = response.data.data.image;
          // console.log("response=", this.document);
        }
      });
    },

    winStepper(window_data) {
      this.img = window_data.imgURL;
      if (window_data.type == "coverImage") {
        this.coverImageFile = window_data.selectedFiles;
        // this.noticeData1.image = window_data.imgURL;
      }
    },
    browseDocs(event) {
      // this.docs = event.target.files;

      // for (var i = 0; i < event.target.files.length; i++) {

      // }
      this.docs = null;
      this.docs = event.target.files;

      // for ( var i=0 ;i < this.docs.length;i++)
      // {
      //   this.document.push(this.docs[i])
      // }
      // alert(this.document)
      // console.log("browse",this.docs);
      this.uploadDocs(this.docs);
    },
    // browseImages2(event) {
    //   this.docs2 = event.target.files[0];
    //   this.uploadImage();
    // },

    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/notice/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.query.key,
        },
      }).then((response) => {
        if (response.data.status) {
          this.noticeData1 = response.data.data;
          this.title = response.data.data.title;
          this.description = response.data.data.description;
          this.appLoading = false;
        }
      });
    },
    editData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/notice/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.noticeData1._id,
          title: this.title,
          description: this.description,
        },
      }).then((response) => {
        if (response.data.status) {
          if (this.coverImageFile) {
            this.uploadImage();
          } else {
            this.$router.push({ path: "/noticeboard2" });
          }
          this.showsnackbar = true;
          this.msg = "Success";
          this.appLoading = false;
          //  this.uploadDocs();
          //  this.$router.go();
        } else {
          this.showsnackbar = true;
          this.msg = "failed";
        }
      });
    },
    removeNotice(item) {
      axios({
        method: "post",
        url: "/notice/remove",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: item,
        },
      }).then((response) => {
        if (response.data.status) {
          this.showsnackbar = true;
          this.msg = "Successfully removed";
          this.$router.push({ path: "/noticeboard2" });
        } else {
          this.showsnackbar = true;
          this.msg = "Failed";
        }
      });
    },
    removeDoc(para) {
      axios({
        method: "post",
        url: "/notice/removedoc",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.noticeData1._id,
          position: para + 1,
        },
      }).then((response) => {
        if (response.data.status) {
          // this.showsnackbar = true;
          // this.msg = "Successfully removed Document";
          this.documentUpdate();
        } else {
          this.showsnackbar = true;
          this.msg = "failed to remove Document";
        }
      });
    },
    uploadDocs(val) {
      this.docsdata.append("id", this.noticeData1._id);
      {
        for (var i = 0; i < val.length; i++) {
          this.docsdata.append("docs", val[i]);
        }
      }

      // this.docs = [];
      // this.docsdata.append("docs", this.docs);
      axios({
        method: "post",
        url: "/notice/uploaddocs",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.docsdata,
      }).then((response) => {
        if (response.data.status) {
          this.document = [];
          this.docs = [];
          this.docsdata = new FormData();
          this.documentUpdate();
        } else {
          console.log("failed to upload doc");
        }
      });
    },
    uploadImage() {
      this.photo.append("id", this.noticeData1._id);
      this.photo.append("photo", this.coverImageFile);
      axios({
        method: "post",
        url: "/notice/uploadimage",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.photo,
      }).then((response) => {
        if (response.data.status) {
          this.documentUpdate();
          this.$router.push({ path: "/noticeboard2" });
        } else {
          console.log("failed");
        }
      });
    },
  },
};
</script>